var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 14",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2,2h11c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1H2C1.4,4,1,3.6,1,3l0,0C1,2.4,1.4,2,2,2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,6h11c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1H2C1.4,8,1,7.6,1,7l0,0C1,6.4,1.4,6,2,6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,10h11c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1H2c-0.6,0-1-0.4-1-1l0,0C1,10.4,1.4,10,2,10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.7c430fb3f5dbd4f34b7876695441712d.svg";
export { ForwardRef as ReactComponent };